import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Coupon } from '@app/entity/coupon';
import { animations } from '@app/shared/coupons-list/coupons-list.animations';

@Component({
  selector: 'app-coupons-list',
  animations: animations,
  templateUrl: './coupons-list.component.html',
  styleUrls: ['./coupons-list.component.scss']
})
export class CouponsListComponent implements OnInit {
  @Input() coupons: Coupon[] = [];

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/coupons-list/coupons-list.component.ts